<script lang="ts">import { formatLargeNumbers } from "../utils";
import { Card } from "@infinitro/card";
import { loggedIn, providerBasePath, toSiteUrl } from "@infinitro/global";
import { CurrencyIcon } from "@infinitro/icons";
import { InfoCard } from "@infinitro/info-card";
import { Icon as RankIcon } from "@infinitro/rank-badges";
import { Text } from "@infinitro/text";
export let liveWin;
const truncatedUsername = () => {
	return liveWin.username?.length > 10 ? `${liveWin.username?.slice(0, 8)}...` : liveWin.username;
};
</script>

<InfoCard noPadding>
	<div class="live-win-content">
		<div class="game-win">
			<a
				href={toSiteUrl(
					`${providerBasePath(liveWin.providerSlug)}${liveWin.providerSlug}/${liveWin.providerSlug === 'sports' ? liveWin.gameSlug : liveWin.gameSlug}`,
					$loggedIn
				) || '#'}
			>
				<Card
					item={{
						game: liveWin.gameSlug,
						prov: liveWin.providerSlug,
						tile: `${providerBasePath(liveWin.providerSlug)}${liveWin.providerSlug}/${liveWin.gameSlug}`,
						alt: `${liveWin.gameSlug} by ${liveWin.providerSlug}`
					}}
					thumbnailBig
					showOverlay={false}
				/>
			</a>
		</div>
		<div class="info-win">
			<div class="username-container">
				<!-- <RankIcon rank={liveWin.rank} level={liveWin.level} size={16} /> -->
				<Text type="body" bodySize="small">{truncatedUsername()}</Text>
			</div>
			<div class="bet-payout">
				<div class="bet-payout-item">
					<div class="d-flex">
						<CurrencyIcon currency={liveWin.currency} size={'16'} />
						<Text
							type="body"
							bodySize="small"
							bodyWeight="bold"
							textColor="primary"
							customStyle="padding-top: 2px;"
						>
							{formatLargeNumbers(liveWin.paidCurrency)}
						</Text>
					</div>
				</div>
			</div>
		</div>
	</div>
</InfoCard>

<style>
	.live-win-content {
		position: relative;
		display: flex;
		height: 81px;
		width: 142px;
		align-items: center;
		justify-content: space-between;
		padding: 0.25rem;
		aspect-ratio: 142 / 81
}

	.username-container {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: center;
		gap: 0.25rem
}

	.bet-payout {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-between
}

	.bet-payout-item {
		display: flex;
		width: 100%;
		flex-direction: column;
		align-items: flex-start;
		padding-left: 0.125rem
}

	.d-flex {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: flex-start;
		gap: 0.125rem
}

	.game-win {
		display: flex;
		height: 100%;
		width: -moz-fit-content;
		width: fit-content;
		flex-direction: column;
		align-items: flex-start;
		padding-left: 0.125rem
}

	.info-win {
		display: flex;
		height: 100%;
		width: 100%;
		flex-direction: column;
		justify-content: center;
		gap: 0.25rem;
		padding-left: 0.125rem
}
</style>
